import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    deviceNameErrorMsg,
    IPAddressErrorMsg
} from '../../../config/constant'
import {
    setAdminPage,
    roomSelectorStatus,
    testIP,
    setLoadingMass,
    popupOpenClose,
    setConnectorIP,
    setDeviceName
} from '../../../action/action'
import { setWebViewAfterKeyBoard } from '../../../JS/setWebView'
import axios from 'axios'
import { setAdminLoginPage } from '../../action/homeAction'

class DeviceRegistration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: false,
            IP: localStorage.getItem("ConnectorIP") || sessionStorage.getItem("ConnectorIP") || process.env.REACT_APP_INTERNAL_IP || process.env.REACT_APP_SERVER_IP,
            error: false,
            errorMsg: null,
            deviceName: localStorage.getItem("deviceName") || null,
            deviceError: false,
            deviceErrorMsg: null,
            timeBound: false,
            popupCheckBound: false,
            marketSegment: localStorage.getItem("marketSegment") || process.env.REACT_APP_MARKET_SEGMENT || null,
            clientId: localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG
        }
    }
    componentDidMount() {
    }
    onNoClick = () => {
        this.props.setAdminLoginPage(false);
    }
    validate = (deviceName, IPAddress) => {
        let digit, octet, index = 0, status = true, error, octetCount = 4;
        if (!IPAddress) {
            this.setState({ error: true, errorMsg: deviceNameErrorMsg });
        } else {
            for (let i = 1; i <= IPAddress.length; i++) {
                if (octetCount < 1) {
                    status = false
                    error = "Octet can't be more than 4 in IP."
                    //console.log("more than 4 octet.");
                }
                digit = IPAddress.charAt(i);
                if (digit === "." || i === IPAddress.length) {
                    octet = IPAddress.substring(index, i);
                    //console.log("octet", octet);
                    octet = parseInt(octet);
                    if (octet > 255) {
                        //console.log(`"${octet}" Octet can't be greter than 255`);
                        status = false;
                        error = `"${octet}" Octet can't be greter than 255`
                    }
                    octetCount--;
                    index = i + 1;
                }
            }
        }
        return { status: status, error: error };
    }
    outOfTimeBound = () => {
        console.log("function called")
        if (this.state.popupCheckBound) {
            this.setState({ popupCheckBound: false });
        }
        else {
            this.props.popupOpenClose(true, this.props.stringConst.inValid);
            this.props.setLoadingMass(false);
            this.setState({ timeBound: true });
        }
        // console.log("how many");
    }
    handleSubmit = (event) => {
        let srcElement, validationStatus;
        event.preventDefault();
        event.srcElement ? srcElement = event.srcElement
            : srcElement = { deviceName: {}, IPAddress: {} }
        let deviceName = event.target.deviceName.value || srcElement.deviceName.value;
        let IPAddress = event.target.IPAddress.value || srcElement.IPAddress.value;
        // console.log("fields are : "+deviceName, IPAddress)
        validationStatus = this.validate(deviceName, IPAddress);
        if (validationStatus.status) {
            console.log("deviceName and IPAddress", deviceName, IPAddress);
            this.state.clientId && localStorage.setItem("clientId",this.state.clientId)
            this.state.marketSegment && localStorage.setItem("marketSegment",this.state.marketSegment)
            setTimeout(() => {
                this.outOfTimeBound();
            }
                , 15000);
            this.props.setLoadingMass(true);
            this.props.testIP(IPAddress, this.IPCallback, deviceName);
        } else {
            this.setState({ error: true, errorMsg: validationStatus.error });
        }
    }

    IPCallback = (status, IP, deviceName) => {
        if (status) {
            this.setState({ popupCheckBound: true });
            console.log("IPCallback if");
            this.props.setConnectorIP(IP);
            this.props.setDeviceName(deviceName);
            deviceName && localStorage.setItem("deviceName", deviceName)
            this.props.roomSelectorStatus(true);
            console.log("this.state.popupCheckBound", this.state.popupCheckBound);
            //clearTimeout(this.timeoutTimer);
            //this.timeoutTimer = 0
        } else {
            console.log("IPCallback else");
            if (this.state.timeBound) {
                this.setState({ timeBound: false });
            }
            else {
                this.props.popupOpenClose(true, this.props.stringConst.inValid);
                this.props.setLoadingMass(false);
                this.setState({ popupCheckBound: true });
            }
            //clearTimeout(this.timeoutTimer);
            // this.timeoutTimer = 0
        }

    }

    chakeforDigit = (event) => {
        let reg = new RegExp('([0-9])');
        let len = event.target.value.length;
        let str = event.target.value.charAt(len - 1);
        this.setState({ IP: event.target.value, error: false });
        return
        if (str.match(reg)) {
            this.setState({ IP: event.target.value, error: false });
        } else if (str === '.' && len > 1) {
            //console.log("in the dot");
            if (len < 2) {
                //console.log("invalid dot.");

            } else {
                let j = len - 2;
                for (let i = 0; i < 4; i++) {
                    if (event.target.value.charAt(j) === '.' && i === 0) {
                        console.log("invlaid two dots.");
                        this.setState({
                            IP: event.target.value.substring(0, len - 1),
                            error: true, errorMsg: 'consequent "." are not allowed.',
                        });
                        break;
                    }
                    if (event.target.value.charAt(j) === '.') {
                        let sub = event.target.value.substring(j + 1, len - 1);
                        sub = parseInt(sub);
                        console.log(
                            "event.target.value.substring(1, 3)",
                            event.target.value.substring(j + 1, len - 1));
                        if (sub > 255) {
                            console.log("invalid input");
                        }
                        break;
                    }
                    j--;
                    this.setState({ IP: event.target.value, error: false });
                }
            }
        } else {
            // console.log("not valid input");
            this.setState({
                IP: event.target.value.substring(0, len - 1),
                error: true, errorMsg: `"${str}" is invalid input character.`
            });
        }
    }

    chakeForDeviceName = (event) => {
        let dReg = new RegExp('^[a-zA-Z0-9 ]+$');
        let len = event.target.value.length;
        let str = event.target.value.charAt(len - 1);
        if (str.match(dReg) || str === "-" || str === "_") {
            //console.log("dReg is true.");
            this.setState({ deviceName: event.target.value, deviceError: false });
        } else {
            this.setState({
                deviceName: event.target.value.substring(0, len - 1),
                deviceError: true, deviceErrorMsg: `${str} is invalid input character.`
            });
        }
    }

    submitKeyEvent = (event) => {
        if (event.keyCode === 13) {
            console.log("keycode", event.keyCode);
            //let currentFocusedEle = document.getElementById("ipAddressField");
            //var type = currentFocusedEle.hasAttribute('type');
            document.getElementById("devRegNext").click();
            event.preventDefault();
        }
    }

    nameKeyReload = (event) => {
        console.log("name it");
        event.preventDefault();
    }

    render() {
        return (
            <div id="connectorReg" className="form">
                <form onSubmit={this.handleSubmit} style={{ color: "black" }}>
                    <div className="form-item" style={{ color: "inherit" }}>
                        <label for="client-name" style={{ color: "inherit" }}>
                            {this.props.stringConst.deviceName}
                        </label>
                        <input
                            type="text"
                            name="deviceName"
                            maxlength="50"
                            onChange={this.chakeForDeviceName}
                            // onKeyDown={this.nameKeyReload}
                            value={this.state.deviceName}
                            style={{ width: "100%", color: "inherit" }}
                            onBlur={(event) => { setWebViewAfterKeyBoard(event) }} />
                    </div>
                    <div style={{ paddingLeft: "1rem", color: "red", fontWeight: "bold" }}>
                        {
                            this.state.deviceError ?
                                this.state.deviceErrorMsg : null
                        }
                    </div>
                    <div className="form-item" style={{ color: "inherit" }}>
                        <label for="client-comment" style={{ color: "inherit" }}>{this.props.stringConst.connectorIP}</label>
                        <input
                            id="ipAddressField"
                            type="text"
                            // span="0.01"
                            name="IPAddress"
                            value={this.state.IP}
                            // inputmode="number"
                            // pattern="((^|\.)((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]?\d))){4}$"
                            // pattern="[0-9]*"
                            placeholder=""
                            // minlength="7"
                            // maxlength="15"
                            style={{ width: "100%", color: "inherit" }}
                            onChange={this.chakeforDigit}
                            onKeyDown={this.submitKeyEvent}
                            onBlur={(event) => { setWebViewAfterKeyBoard(event) }}
                            required />
                    </div>
                    <div style={{ paddingLeft: "1rem", color: "red", fontWeight: "bold" }}>
                        {
                            this.state.error ?
                                this.state.errorMsg : null
                        }
                    </div>
                    <div className="form-item" style={{ color: "inherit" }}>
                        <label for="client-name" style={{ color: "inherit" }}>
                            Client ID
                        </label>
                        <input
                            type="text"
                            name="deviceName"
                            maxlength="50"
                            onChange={(e) => this.setState({clientId: e.target.value})}
                            // onKeyDown={this.nameKeyReload}
                            value={this.state.clientId}
                            style={{ width: "100%", color: "inherit" }}
                            onBlur={(event) => { setWebViewAfterKeyBoard(event) }} />
                    </div>
                    {/* <div className="form-item" style={{ color: "inherit" }}>
                        <label for="client-name" style={{ color: "inherit" }}>
                            Market Segment
                        </label>
                        <input
                            type="text"
                            name="deviceName"
                            maxlength="50"
                            onChange={(e) => this.setState({marketSegment: e.target.value})}
                            // onKeyDown={this.nameKeyReload}
                            value={this.state.marketSegment}
                            style={{ width: "100%", color: "inherit" }}
                            onBlur={(event) => { setWebViewAfterKeyBoard(event) }} />
                    </div> */}
                    <div className="form-controls">
                        <button type="submit" id="devRegNext" className="primary">{this.props.stringConst.connect}</button>
                        <button className="secondary" onClick={this.onNoClick}>{this.props.stringConst.cancel}</button>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        stringConst: state.store.home.stringConst,
    }
}
export default connect(
    mapStateToProps,
    {
        setAdminPage,
        roomSelectorStatus,
        testIP,
        setLoadingMass,
        popupOpenClose,
        setConnectorIP,
        setDeviceName,
        setAdminLoginPage
    }
)(DeviceRegistration);